import { useEffect, useState } from "react";

/** Delays reflecting `value` until it's stopped changing for `delayMs` —
 * for a search box wired straight to a query key, so every keystroke doesn't
 * fire its own request. 300ms is the debounce most search UIs converge on:
 * short enough to feel live, long enough that normal typing speed doesn't
 * trigger a request per character. */
export function useDebounced<T>(value: T, delayMs: number): T {
  const [debounced, setDebounced] = useState(value);
  useEffect(() => {
    const timer = setTimeout(() => setDebounced(value), delayMs);
    return () => clearTimeout(timer);
  }, [value, delayMs]);
  return debounced;
}
